const notificationTypes = {
	wallet: 'Wallet',
	paymentInstrument: 'Payment Instrument',
	walletAccount: 'Wallet Account',
	voucher: 'Voucher',
	tradeConfiguration: 'Trade Configuration',
	passwordForgottenProcess: 'Password Forgotten Process'
};

const notificationSubtypes = {
	Created: 'Created',
	Activated: 'Activated',
	Locked: 'Locked',
	Unlocked: 'Unlocked',
	Invalidated: 'Invalidated',
	Terminated: 'Terminated',
	Deleted: 'Deleted',
	Updated: 'Updated',
	Expired: 'Expired',
	Confirmed: 'Confirmed',
	Completed: 'Completed',
	Failed: 'Failed',
	RolesUpdated: 'RolesUpdated',
	Upgraded: 'Upgraded',
	PasswordUpdated: 'PasswordUpdated',
	FailedLogin: 'FailedLogin',
	UserIdentifierDeleted: 'UserIdentifierDeleted',
	Verified: 'Verified',
	Commented: 'Commented',
	DisputeStarted: 'Dispute Started',
	DisputeLost: 'Dispute Lost',
	DisputeWon: 'Dispute Won'
};

const notificationTypesForSelection = Object.keys(notificationTypes).map(key => {
	return { id: key, name: notificationTypes[key] };
});
const notificationSubtypesForSelection = Object.keys(notificationSubtypes).map(key => {
	return { id: key, name: notificationSubtypes[key] };
});

export { notificationTypesForSelection, notificationSubtypesForSelection };
